export enum ENewRelicActions {
  Login = 'punterLogIn',
  LogOut = 'punterLogOut',
  Deposit = 'punterDeposit',
}
